
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.95 12.187l-.771-.771L40.084 1.321 39.313.55A1.891 1.891 0 0037.985 0H8.963C7.777 0 6.5.916 6.5 2.926V56c0 .837.842 1.653 1.838 1.91.05.013.098.032.15.042.156.031.315.048.475.048h40.074c.16 0 .319-.017.475-.048.052-.01.1-.029.15-.042.996-.257 1.838-1.073 1.838-1.91V13.978c0-.767-.092-1.333-.55-1.791zM47.935 12H39.5V3.565L47.935 12zM8.963 56c-.071 0-.135-.026-.198-.049a.458.458 0 01-.265-.414V41h41v14.537a.46.46 0 01-.265.414c-.063.023-.127.049-.198.049H8.963zM8.5 39V2.926c0-.217.033-.926.463-.926h28.595a1.54 1.54 0 00-.058.391V14h11.609c.135 0 .264-.025.39-.058l.001.036V39h-41z"}}),_c('path',{attrs:{"d":"M16.414 54h6.303v-1.244h-4.635v-3.295h4.211V48.34h-4.211v-3.172h4.635v-1.244h-6.303zM30.428 43.924L28.5 48.025h-.137l-1.777-4.101h-1.873l2.721 5.181L24.877 54h1.9l1.723-3.801h.137L30.236 54h1.901l-2.557-4.895 2.721-5.181zM34.598 54H40.9v-1.244h-4.634v-3.295h4.211V48.34h-4.211v-3.172H40.9v-1.244h-6.302zM39.798 15.045a1 1 0 00-1.253.656l-5 16a1 1 0 001.909.597l5-16a1 1 0 00-.656-1.253z"}}),_c('circle',{attrs:{"cx":"30","cy":"20.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"30","cy":"27.5","r":"1.5"}}),_c('path',{attrs:{"d":"M22.5 19h2a1 1 0 000-2h-2c-3.86 0-7 3.14-7 7s3.14 7 7 7h2a1 1 0 000-2h-2c-2.757 0-5-2.243-5-5s2.243-5 5-5z"}})])
          )
        }
      }
    